<template>
  <div class="main-layout">
    <navbar />
    <div :class="containerClass">
      <child />
    </div>
  </div>
</template>
<script>
import Navbar from '~/components/Navbar'
export default {
  name: 'HomeLayout',
  components: {
    Navbar
  },
  computed: {
    containerClass() {
      var mq = this.$mq
      var classArr = ['mt-2']
      if (mq == 'xl') classArr.push('container')
      else classArr.push('container-fluid')
      if (mq == 'xs') classArr.push('px-2')
      return classArr
    }
  }
}

</script>
<style lang="scss">
.basic-layout {
  color: #636b6f;
  height: 100vh;
  font-weight: 100;
  position: relative;

  .links>a {
    color: #636b6f;
    padding: 0 25px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: .1rem;
    text-decoration: none;
    text-transform: uppercase;
  }
}

</style>
